/**
 * KAN-873: строка пометок настройки сверху вкладок приложения менеджера (/m).
 * Заменила плашку "Настройка не закончена" (KAN-868) и плашку телефона
 * (KAN-837), правила показа прежние: уведомления и Telegram по
 * getSetupPending, телефон: нет телефона и это не вкладка "Профиль".
 * На экране "Начало работы" строки нет.
 */
import type { OnboardingStepId } from '@/lib/managerOnboarding';
import type { SetupPending } from '@/lib/managerSetupPending';
import { MOBILE_PROFILE_PATH, MOBILE_START_PATH } from '@/lib/mobileApp';

export type SetupChipId = Extract<OnboardingStepId, 'push' | 'telegram' | 'phone'>;

export const SETUP_CHIPS_TITLE = 'Настройка не закончена';

export const SETUP_CHIP_LABELS: Record<SetupChipId, string> = {
  push: 'Уведомления',
  telegram: 'Telegram',
  phone: 'Телефон',
};

export interface SetupChipsInputs {
  /** null: статус уведомлений неизвестен, пометок уведомлений и Telegram нет. */
  pending: SetupPending | null;
  missingPhone: boolean;
  pathname: string;
}

export function getSetupChips({ pending, missingPhone, pathname }: SetupChipsInputs): SetupChipId[] {
  const path = pathname.replace(/\/+$/, '');
  if (path === MOBILE_START_PATH) return [];
  const chips: SetupChipId[] = [];
  if (pending?.push) chips.push('push');
  if (pending?.telegram) chips.push('telegram');
  if (missingPhone && path !== MOBILE_PROFILE_PATH) chips.push('phone');
  return chips;
}
